<template>
  <PageLayout :screenWidth="windowWidth" :loaded="meta.loaded">
    <section class="app-section app-section-light-grey container-fluid">
      <section class="container" id="edit-column-width">
        <section v-if="typeHoneymoon" class="row" id="edit-column-width">
          <div class="col-md-10 col-md-push-1 text-center">
            <img
              src="/graphics/weddings/logo-tf-wishlist.png"
              class="img-responsive w-50"
              style="margin-left:auto;margin-right:auto"
            />

            <h1 class="pt-3">How the Trailfinders Honeymoon Wishlist works</h1>

            <div class="mainTxtNorm pt-3">
              <p class="pt-2">
                You’ll have your own personalised website where your friends and
                family can share in your excitement, keep up to date with your
                wedding and honeymoon plans, make a contribution and post their
                congratulations.
              </p>

              <p class="pt-2">
                We'll provide you with personalised guest cards (electronic
                and/or printed) for your invitations which will let everyone
                know your preference for the gift of travel. Each time your
                guests contribute to your Wishlist we’ll send you an alert and
                an automated thank you on your behalf.
              </p>

              <p class="pt-2">
                When creating your Wishlist we recommend you setting a closing
                date at least one week after the wedding, allowing time for
                those last minute gifts. The closing date is editable however
                once it’s passed the Wishlist is closed and no more
                contributions can be made.
              </p>

              <p class="pt-2">
                All contributions will be held safely in our Trust Account and
                can be transferred to your Trailfinders Honeymoon or, if you are
                yet to book, sent to you as a Trailfinders Electronic Gift Card.
                Any excess funds beyond the holiday value will be added to a
                Trailfinders Electronic Gift Card, which are valid indefinitely.
              </p>

              <p class="pt-2">
                Contributions can be made online, over the phone using the
                number
                <strong
                  ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link' : null">{{ telNo }}</a></strong
                >
                or in one of our Travel Centres.
              </p>

              <p class="pt-2">
                In the unlikely event you need to cancel your Wishlist please
                contact our team on
                <strong
                  ><a :href="`tel:${telNoAdminSupport}`" :data-ga4-label="telNoAdminSupport === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="telNoAdminSupport === '020 7368 1404' ? 'text_link' : null">{{ telNoAdminSupport }}</a></strong
                >. This will enable us to close the Wishlist to prevent further
                contributions and arrange for refunds.
              </p>
            </div>
            <hr class="hr-02" />
          </div>
        </section>
        <section v-if="!typeHoneymoon" class="row justify-content-center" id="edit-column-width">
          <div class="col-md-10 col-md-push-1 text-center">
            <img
              src="/graphics/giftlist/logo-tf-giftlist-noback.png"
              class="img-fluid w-50 pb-5"
            />

            <h1>How the Trailfinders Wishlist works…</h1>
            <br />

            <div class="mainTxtNorm">
              <p>
                Alongside the service of our award winning Travel Consultants,
                the Trailfinders Celebration Wishlist is a simple way for
                friends, family and colleagues to contribute towards a holiday
                of a lifetime.
              </p>

              <p>
                You’ll have a personalised website where friends, family or
                colleagues can share in the excitement, keep up to date with
                holiday plans, make a contribution and post messages.
              </p>

              <p>
                We'll provide you with personalised guest cards (electronic
                and/or printed) which can be shared with all those wishing to
                contribute. Every contribution prompts an alert to the organiser
                and an automated thank you to the contributor.
              </p>

              <p>
                When creating a Wishlist we recommend you set a closing date at
                least one week after the event, allowing time for those last
                minute gifts. The closing date is editable however once it’s
                passed the Wishlist is closed and no more contributions can be
                made.
              </p>

              <p>
                All contributions will be held safely in our Trust Account and
                can be transferred to your Trailfinders holiday or, if you are
                yet to book, sent to you as a Trailfinders Electronic Gift Card.
                Any excess funds beyond the holiday value will be added to a
                Trailfinders Electronic Gift Card which is valid indefinitely.
              </p>

              <p>
                Contributions can be made online, over the phone
                <strong
                  ><a :href="`tel:${telNo}`" :data-ga4-label="telNo === '020 7084 6512' ? 'dedicated_honeymoon_team' : null" :data-ga4-category="telNo === '020 7084 6512' ? 'text_link' : null">{{ telNo }}</a></strong
                >
                or in one of our Travel Centres.
              </p>

              <p>
                TIn the unlikely event you need to cancel your wishlist please
                contact our team on
                <strong
                  ><a :href="`tel:${telNoAdminSupport}`" :data-ga4-label="telNoAdminSupport === '020 7368 1404' ? 'wishlist_admin' : null" :data-ga4-category="telNoAdminSupport === '020 7368 1404' ? 'text_link' : null">{{ telNoAdminSupport}}</a></strong
                >. This will enable us to close the wishlist to prevent further
                contributions and arrange for refunds.
              </p>
            </div>

            <hr class="hr-02" />
          </div>
        </section>
      </section>
    </section>
  </PageLayout>
</template>

<script>
export default {
  data() {
    return {
      meta: {
        loaded: true
      },
      date: null,
      typeHoneymoon: null,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      editButton: false,
      isIe: false,
      telNo: null,
      telNoAdminSupport: null
    };
  },
  mounted() {
    if (this.$route.params.wishlistType === "honeymoon") {
      this.typeHoneymoon = true;
    } else {
      this.typeHoneymoon = false;
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize());
    });
    if (window.location.toString().indexOf("trailfinders.ie") > 0) {
      this.telNo = "01 881 4990";
      this.telNoAdminSupport = "01 881 4990";
      this.isIe = true;
    } else if (
      window.location.toString().indexOf("trailfinders.com") > 0 &&
      this.$store.state.wishlistType === "giftlist"
    ) {
      this.telNo = "020 7408 9008";
      this.telNoAdminSupport = "020 7368 1404";
      this.isIe = false;
    } else {
      this.telNo = "020 7084 6512";
      this.telNoAdminSupport = "020 7368 1404";
      this.isIe = false;
    }
    this.meta.loaded = true;
    this.date = Date.now();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if (window.innerWidth < 790) {
        this.vertical = true;
      } else {
        this.vertical = false;
      }
    }
  }
};
</script>
